export default {
    items: [{
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer'
    }, {
        name: 'Practice',
        url: '/practice',
        icon: 'icon-settings',
        children: [{
            name: 'Location',
            url: '/practice/location',
            icon: 'icon-location-pin'
        }, {
            name: 'Privacy Officer',
            url: '/practice/po',
            icon: 'icon-star'
        }, {
            name: 'Job Roles',
            url: '/practice/roles',
            icon: 'icon-mustache'
        }, {
            name: 'Logbook',
            url: '/practice/logbook',
            icon: 'icon-note'
        }]
    }, {
        name: 'Workforce',
        url: '/workforce-list',
        icon: 'icon-people'
    }, {
        name: 'ePHI Inventory',
        url: '/inventory-list',
        icon: 'icon-screen-desktop'
    }, {
        name: 'Business Associates',
        url: '/ba-list',
        icon: 'icon-notebook'
    }, {
        name: 'Policies & Procedures',
        url: '/policy-list',
        icon: 'icon-book-open'
    }, {
        name: 'Training',
        url: '/training-docs',
        icon: 'icon-graduation'
    }, {
        name: 'Activity Review',
        url: '/activity-list',
        icon: 'icon-eye'
    }, {
        name: 'Risk Management',
        url: '/risk',
        icon: 'icon-shield'
    }, {
        name: 'Mitigation Tasks',
        url: '/task-list',
        icon: 'icon-note'
    }, {
        name: 'Sample Forms',
        url: '/forms',
        icon: 'icon-docs'
    }, {
        divider: true
    }]
}